// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/swiper/css/swiper.css
// module id = 244
// module chunks = 0